import { render, staticRenderFns } from "./SupervisorMonitor.vue?vue&type=template&id=89fab570&"
import script from "./SupervisorMonitor.vue?vue&type=script&lang=js&"
export * from "./SupervisorMonitor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports